export default "/images/sales.png?7c59007ec36e0be8b9d49bb066d44a84";